import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { TreeService } from 'src/app/services/Tree/tree.service';
import { UtilsService } from 'src/app/services/Utils/utils.service';
import { MediaTree, FolderNode, SelectFolderData } from 'src/app/utils/common-classes';
import { FileManagerComponent } from 'src/app/components/file-manager/file-manager.component';
import { FolderTreeComponent } from 'src/app/components/folder-tree/folder-tree.component';
import { MatSelectChange, MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  @ViewChild(FileManagerComponent, { static: true })
  public fileManager: FileManagerComponent;

  @ViewChildren(FolderTreeComponent)
  public treeComponentList: Array<FolderTreeComponent>;

  public lang: string;

  public trees: Array<MediaTree> = [];
  public selectedFolder: FolderNode;
  public selectedTree: MediaTree;

  constructor(
    private router: Router,
    private authService: AuthService,
    private treeService: TreeService,
    public utils: UtilsService,
    private translate: TranslateService) {
    let _self = this;
    _self.utils.showShortLoader();
    _self.lang = _self.utils.getLanguage();
    _self.translate.use(_self.lang);
    _self.treeService.getTrees().then((trees: Array<MediaTree>) => {
      _self.trees = trees;
    }).catch((err) => {
      return _self.utils.getErrorShowToast(err);
    }).finally(() => {
      _self.utils.hideShortLoader();
    });
  }

  ngOnInit() { }

  public logout(): void {
    let _self = this;
    _self.authService.logout().then(() => {
      _self.router.navigate(['login']);
    });
  }

  public selectFolder(folder: SelectFolderData): void {
    let _self = this;
    _self.treeComponentList.forEach((component) => {
      component.folderSelected(folder.node);
    });
    _self.selectedFolder = folder.node;
    _self.selectedTree = folder.tree;
    _self.fileManager.loadFolder(folder.node, folder.tree);
  }

  public changeLanguage(event: MatSelectChange): void {
    this.utils.setLanguage(this.lang);
  }

}